import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {

  GET_PROVIDER_GAP_REPORT_REQUEST: '',
  GET_PROVIDER_GAP_REPORT_SUCCESS: '',
  GET_PROVIDER_GAP_REPORT_FAILURE: '',

  GET_PROVIDER_HEDIS_GAP_REQUEST: '',
  GET_PROVIDER_HEDIS_GAP_SUCCESS: '',
  GET_PROVIDER_HEDIS_GAP_FAILURE: '',

  GET_LAST_RUN_GAP_DATE_REQUEST: '',
  GET_LAST_RUN_GAP_DATE_SUCCESS: '',
  GET_LAST_RUN_GAP_DATE_FAILURE: '',

  DOWNLOAD_DOCUMENT_REQUEST: '',
  DOWNLOAD_DOCUMENT_SUCCESS: '',
  DOWNLOAD_DOCUMENT_FAILURE: '',
};

types = setStoreTypeValues(types, 'eligibilityGAP');

export default types;
